import { __assign } from "tslib";
export var REGEX_URL = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
export var isUrl = function (value) { return REGEX_URL.test(value); };
/**
 * parseSearchParams
 * Takes a string with url search params and returns an object
 * with key - value pairs
 */
export var parseSearchParams = function (str) {
    var params = str instanceof URLSearchParams ? str : new URLSearchParams(str);
    var result = {};
    // in some browsers params can be an empty object
    if (typeof params.forEach !== "function") {
        return result;
    }
    params.forEach(function (value, key) {
        if (key in result) {
            if (!Array.isArray(result[key])) {
                result[key] = [result[key]];
            }
            result[key].push(value);
        }
        else {
            result[key] = value;
        }
    });
    return result;
};
/**
 * parseSearchParamsByUrl
 * @param url
 */
export var parseSearchParamsByUrl = function (url) {
    return parseSearchParams(new URL(url).search);
};
/**
 * stringifySearchParams
 * Takes an object with search params (key => value) and returns a urls search string
 * like i.e. debug=false&includeWidgetConfigs=true (for input { debug: false, includeWidgetConfigs: true })
 */
export var stringifySearchParams = function (params) { return new URLSearchParams(params).toString(); };
/**
 * setUrlParams
 * Set url params and make sure no duplicates exist in url
 * @param url
 * @param params
 */
export var setUrlParams = function (url, params) {
    var parsedUrl = new URL(url);
    var urlWithoutParams = [parsedUrl.origin, parsedUrl.pathname].join("");
    var orginalParams = parseSearchParams(parsedUrl.searchParams);
    var newParams = __assign(__assign({}, orginalParams), params);
    return urlWithoutParams + "?" + stringifySearchParams(newParams) + parsedUrl.hash;
};
/**
 * getFilename
 * @param url
 */
export var getFilename = function (url) { return url.substring(url.lastIndexOf("/") + 1); };
/**
 * stripTrailingSlash
 * @param url
 */
export var stripTrailingSlash = function (url) {
    return url[url.length - 1] === "/" ? url.substr(0, url.length - 1) : url;
};
/**
 * Helper to resolve subdomain from url string or URL instance
 * @param url
 */
export var getSubdomain = function (url, options) {
    if (options === void 0) { options = {}; }
    var segments = resolveDomainSegments(url, options);
    return segments.length > 2 ? segments[0] : null;
};
/**
 * Helper to resolve topdomain from url string or URL instance
 * @param url
 */
export var getTopdomain = function (url, options) {
    if (options === void 0) { options = {}; }
    var segments = resolveDomainSegments(url, options);
    return (segments === null || segments === void 0 ? void 0 : segments[segments.length - 1]) || null;
};
var resolveDomainSegments = function (url, _a) {
    var ignoreWww = _a.ignoreWww;
    var hostname = url instanceof URL ? url.hostname : new URL(url).hostname;
    var segments = hostname.split(".");
    if (ignoreWww && segments[0].toLocaleLowerCase().trim() === "www") {
        segments = segments.slice(1);
    }
    return segments;
};
//# sourceMappingURL=Url.js.map